import { useTranslation } from 'react-i18next';
import { supportedLanguages } from '../i18n';
import { Globe } from 'lucide-react';
import { authFetch } from '../lib/authFetch';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function LanguageSelector({ userTier }) {
  const { i18n } = useTranslation();

  const handleLanguageChange = async (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('pangaji_language', langCode);

    try {
      await authFetch(`${API}/auth/language`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ language: langCode }),
      });
    } catch {
      // Silently fail — localStorage already updated
    }
  };

  return (
    <div className="flex items-center gap-1.5">
      <Globe className="hidden sm:block w-4 h-4 text-muted-foreground flex-shrink-0" />
      <select
        value={i18n.language}
        onChange={(e) => handleLanguageChange(e.target.value)}
        aria-label="Language"
        data-testid="language-selector"
        className="bg-background border border-input rounded-none font-mono text-xs px-2 py-1 text-foreground focus:ring-1 focus:ring-primary focus:border-transparent"
      >
        {supportedLanguages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.flag} {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
}
